<template>
  <el-form :rules="rules" :model="setting" ref="publicPoolDropForm">
    <!-- 公客池掉落规则 -->
    <div class="clearfix rule-con mt20">
      <p class="desc floatL"><b>公客池掉落规则</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="data.auto_shift_public_status">
          <el-radio :label="0">
            <span class="checkbox-label">禁用</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">启用</span>
          </el-radio>
        </el-radio-group>
        <el-popover placement="top-start" trigger="hover">
          <div class="popover-info">
            <p>1、计时：从经纪人获取用户的分配时间开始计算（包括手工录入、批量导入、转让接收、公客池抢客、手工分配、自动分配）</p>
            <p>2、对客户的新增、编辑、写跟进、提交业务审批单都视为跟进客户。</p>
            <p>3、某项时间设置为0时，则表示跳过该项限制。</p>
            <p>4、规则开启或更新后将会在次日0点生效。</p>
            <p>5、本规则仅对未成交客户生效。</p>
          </div>
          <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
        </el-popover>
      </div>
      <!-- 提示是否有规则更新 -->
      <p class="update-tips" v-if="data.auto_shift_public_status != data.auto_shift_public_status_active">{{data.auto_shift_public_status == 1 ? '当前规则为禁用状态，已改为启用，将在0点生效' : ''}}</p>
      <p class="update-tips" v-else-if="setting.need_update == 1">有更新的规则细节将会在次日0点生效<a @click="handleShowRule">，点击查看当前生效规则</a></p>
      <p class="update-tips" v-else-if="setting.need_update == 2">新开启的规则将会在次日0点生效</p>
    </div>
    <!-- 白名单功能 -->
    <template v-if="data.auto_shift_public_status == 1">
      <div class="clearfix rule-con mt20">
        <p class="desc floatL"><b>白名单：</b>
          <el-popover placement="top-start" trigger="hover">
            <div class="popover-info">
              <p>保存成功后立即生效</p>
            </div>
            <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
          </el-popover>
        </p>
      </div>
      <div class="rule-group-back mt20">
        <div class="clearfix rule-con">
          <p class="desc floatL">不受公客池掉落规则限制的特殊账号：</p>
          <div class="desc floatL dis-auto-users">
            <template v-if="admin_white_list_arr.length > 0">
              <span class="person" v-for="(user, i) in admin_white_list_arr" :key="`admin_white_list_arr_${user.id}`">
                {{user.name}}
                <i class="iconfont iconguanbi" @click="removePublicUser(i, 2)"></i>
              </span>
              <p class="person-total">共<span>{{admin_white_list_arr.length}}</span>人</p>
            </template>
            <el-button icon="el-icon-plus" size="mini" @click="addPublicManual(2)">添加</el-button>
          </div>
        </div>
        <div class="clearfix rule-con">
          <p class="desc floatL">不受公客池掉落规则限制的客户来源：</p>
          <div class="desc floatL dis-auto-users">
            <p class="source-platform-list" v-if="setting.source_white_list_text">{{setting.source_white_list_text || ''}}</p>
            <el-button icon="el-icon-plus" size="mini" @click="addPublicManual(3)">添加</el-button>
          </div>
        </div>
      </div>
    </template>
    <!-- 客户掉落分配抢客提醒 -->
    <div class="clearfix rule-con mt20" v-if="data.auto_shift_public_status == 1">
      <p class="desc floatL"><b>客户掉落分配抢客提醒</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="data.send_public_pool_msg_status">
          <el-radio :label="0">
            <span class="checkbox-label">禁用</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">启用</span>
          </el-radio>
        </el-radio-group>
        <el-popover placement="top-start" trigger="hover">
          <div class="popover-info">
            <p>客户因触发「公客池掉落规则」而掉落到公客池后，提醒其它有权限抢客的人去抢客（客户上一个归属人除外），同时提醒有权限分配客户的人去分配。</p>
          </div>
          <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
        </el-popover>
      </div>
    </div>
    <!-- 不接收此类提醒特殊账号 -->
    <div class="clearfix rule-con mt20 special-rule" v-if="data.send_public_pool_msg_status == 1 && data.auto_shift_public_status == 1">
      <div class="clearfix rule-con">
        <p class="desc floatL" style="font-weight:bold;">不接收此类提醒特殊账号 :  </p>
        <div class="desc floatL dis-auto-users">
          <template v-if="no_drop_notice_admin_arr.length > 0">
            <span class="person" v-for="(user, i) in no_drop_notice_admin_arr" :key="`no_drop_notice_admin_arr${user.id}`">
              {{user.name}}
              <i class="iconfont iconguanbi" @click="removePublicUser(i, 1)"></i>
            </span>
            <p class="person-total">共<span>{{no_drop_notice_admin_arr.length}}</span>人</p>
          </template>
          <el-button icon="el-icon-plus" size="mini" @click="addPublicManual(1)">添加</el-button>
        </div>
      </div>
    </div>
    <!-- 规则内容 -->
    <div class="rule-group-back mt20" v-if="data.auto_shift_public_status === 1">
      <div class="setting-table">
        <div class="title-flex">
          <h1 class="header">是否启用</h1>
          <!-- 未开启报备流程不显示报备 -->
          <template v-for="key in switchList">
            <div class="header-name" v-if="!(firmInfo.report_process_status == 2 && key == 'no_report_record_rule')" :key="key">
              <el-switch v-model="setting[key]" :active-value="1" :inactive-value="0"></el-switch>
              <p v-if="setting[key + '_desc']" class="rule-remind">{{setting[key + '_desc']}}</p>
            </div>
          </template>
        </div>
        <div class="content-flex-rule">
          <h1 class="header">规则内容</h1>
          <template v-for="(item, i) in ruleList">
            <!-- 未开启报备流程不显示报备 -->
            <div class="set-content" :key="i" v-if="!(firmInfo.report_process_status == 2 && item.timeProp == 'no_report_record_time')">
              <div class="rule-con">
                <template v-if="item.type == 'custom'">
                  {{item.preText1}} 
                  <el-select v-if='item.name == "no_report_record_flow_type"' v-model="setting[item.name]" placeholder="" class="rule-form custom-select" size="mini">
                    <el-option :value="1" label="分配后">分配后</el-option>
                    <el-option :value="2" label="首次跟进后">首次跟进后</el-option>
                  </el-select>
                  <el-select v-if='item.name == "no_look_record_flow_type"' v-model="setting[item.name]" placeholder="" class="rule-form custom-select" size="mini">
                    <el-option :value="1" label="分配后">分配后</el-option>
                    <el-option :value="2" label="首次跟进后">首次跟进后</el-option>
                    <el-option v-if="firmInfo.report_process_status == 1" :value="4" label="报备后">报备后</el-option>
                  </el-select>
                  <el-select v-if='item.name == "no_subscription_record_flow_type"' v-model="setting[item.name]" placeholder="" class="rule-form custom-select" size="mini">
                    <el-option :value="1" label="分配后">分配后</el-option>
                    <el-option :value="2" label="首次跟进后">首次跟进后</el-option>
                    <el-option v-if="firmInfo.report_process_status == 1" :value="4" label="报备后">报备后</el-option>
                    <el-option :value="5" label="带看后">带看后</el-option>
                  </el-select>
                {{item.preText2}}
                </template>
                <template v-else>
                  {{item.preText}}
                </template>
                <el-form-item :prop="item.timeProp" class="rule-form">
                  <el-input v-model="setting[item.timeProp]" size="mini" />
                </el-form-item>
                <el-select v-model="setting[item.timeUnitProp]" placeholder="" class="rule-form" size="mini">
                  <el-option :value="5" label="分钟" v-if="i == 0">分钟</el-option>
                  <el-option :value="1" label="小时">小时</el-option>
                  <el-option :value="2" label="天">天</el-option>
                </el-select>
                {{item.suffixText}}
              </div>
              <!-- 新客户未跟进选择每日保护时间 -->
              <div v-if="i == 0" class="protect-con">
                  <div class="rule-con">
                      <el-tooltip content="当需要客户在某段时间内不会触发「因超时未跟进」而自动掉落到公客池时，您可以使用此配置功能。"
                          placement="right">
                        <el-button class="settingDateBtn" size="mini" @click="settingDate"><i class="el-icon-setting"></i> 高级设置</el-button>
                      </el-tooltip>
                  </div>
                  <div class="rule-con settingDateBox" v-if="setting.unconfirmed_daily_protect_time_json || setting.unconfirmed_weekly_protect_time || showSetting">
                      在【
                        <el-button size="mini" type="text" @click="handleAddDate(setting)">设置时间段</el-button>
                        <span class="everyDay">{{ getTimeRange }}</span>
                      】内，客户不会触发「因超时未跟进」而自动掉落到公客池。
                  </div>
              </div>
            </div>
          </template>
        </div>
        <div class="content-flex">
          <h1 class="header">经纪人提醒
            <el-popover placement="top-start" trigger="hover">
              <div class="popover-info">
                <p>经纪人提醒时间需早于客户掉落时间哦！</p>
              </div>
              <i class="iconfont popover-info-icon tipMsg" slot="reference">&#xe7e2;</i>
            </el-popover>
          </h1>
          <template v-for="(item, i) in remindList">
            <!-- 未开启报备流程不显示报备 -->
            <div class="set-content" :key="i" v-if="!(firmInfo.report_process_status == 2 && item.timeProp == 'no_report_record_alert_time')">
              <div class="rule-con">
                掉公客池前
                <el-form-item :prop="item.timeProp" class="rule-form">
                  <el-input v-model="setting[item.timeProp]" size="mini" />
                </el-form-item>
                <el-select v-model="setting[item.timeUnitProp]" placeholder="" class="rule-form" size="mini">
                  <el-option :value="5" label="分钟" v-if="i == 0">分钟</el-option>
                  <el-option :value="1" label="小时" :disabled="setting[ruleList[i].timeUnitProp] == 5">小时</el-option>
                  <el-option :value="2" label="天" :disabled="setting[ruleList[i].timeUnitProp] != 2">天</el-option>
                </el-select>
                提醒经纪人
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <select-company-member ref="publicRobRef" @confirm="handleConfirmRob"/>
    <public-pool-drop-actived :info="info" ref="ruleRefs" />
    <public-pool-time-picker ref="timePickerRef" @confirm="handleTimePicker" />
    <public-pool-week-picker ref="weekPickerRef" @confirm="handleWeekPicker" />
    <public-pool-date-picker ref="datePickerRef" @confirm="handleDatePicker" />
    <platform-picker ref="platformPickeRef" @confirm="handlePlatPicker"></platform-picker>
  </el-form>
</template>
<script>
import SelectCompanyMember from '../../../components/selectCompanyMember';
import PublicPoolDropActived from './publicPoolDropActived';
import PublicPoolTimePicker from './publicPoolTimePicker';
import PublicPoolWeekPicker from './publicPoolWeekPicker';
import PublicPoolDatePicker from './publicPoolDatePicker';
import platformPicker from './platformPicker';
import {validateNum} from '../../validateProp';
import { mapState } from 'vuex';
export default{
  name: 'PublicDrop',
  components: {PublicPoolDatePicker, PublicPoolDropActived, PublicPoolTimePicker, PublicPoolWeekPicker,SelectCompanyMember, platformPicker},
  props: {
    info: Object
  },
  watch: {
      'data.auto_shift_public_status': {
          handler (newVal,oldVal){
              if(oldVal != null){
                  this.$EventBus.$emit('changePublicSave', newVal !== this.info.auto_shift_public_status, "drop");
              }
          },
      },
      'data.send_public_pool_msg_status': {
          handler (newVal,oldVal){
              if(oldVal != null){
                  this.$EventBus.$emit('changePublicSave', newVal !== this.info.send_public_pool_msg_status);
              }
          },
      },
      setting:{
          handler (newVal,oldVal){
              if(oldVal.hasOwnProperty("need_update")){
                  this.$EventBus.$emit('changePublicSave', this.data.auto_distribute_business !== this.info.auto_shift_public_status || JSON.stringify(newVal) !== JSON.stringify(this.sourceSetting), "drop");
              }
          },
          deep: true
      },
      no_drop_notice_admin_arr: {
          handler (newVal, oldVal){
            this.$EventBus.$emit('changePublicSave', JSON.stringify(newVal) !== JSON.stringify(this.sourceNDNA));
          },
          deep: true
      },
      admin_white_list_arr: {
          handler (newVal, oldVal){
            this.$EventBus.$emit('changePublicSave', JSON.stringify(newVal) !== JSON.stringify(this.sourceAWLR));
          },
          deep: true
      },
  },
  data () {
    const unitConverstion = {
        2:{
            2:(ruleVal, brokerVal) => {
                return brokerVal <= ruleVal;
            },
            1:(ruleVal, brokerVal) => {
                return (brokerVal / 24) <= ruleVal;
            },
            5:(ruleVal, brokerVal) => {
                return (brokerVal / 24 / 60) <= ruleVal;
            }
        },
        1:{
            1:(ruleVal, brokerVal) => {
                return brokerVal <= ruleVal;
            },
            5:(ruleVal, brokerVal) => {
                return (brokerVal / 60) <= ruleVal;
            }
        },
        5:{
            5:(ruleVal, brokerVal) => {
                return brokerVal <= ruleVal;
            }
        }
    }
    const validatePass2 = (rule, value, callback) => {
        let _this = this,
            _field = rule.field,
            _remindList = _this.remindList,
            _setting = _this.setting,
            _idx;
        _remindList.forEach((v,i) => {
            if(v.timeProp == _field)
                _idx = i;
        })
        let _curRuleTimeUnit = +_setting[_this.ruleList[_idx].timeUnitProp],
            _curRuleTime = +_setting[_this.ruleList[_idx].timeProp],
            _curBrokerTime = +_setting[_this.remindList[_idx].timeProp],
            _curBrokerTimeUnit = +_setting[_this.remindList[_idx].timeUnitProp];

        if (value === '') {
            callback(new Error(`请输入${rule.name}`));
        } else if (!unitConverstion[_curRuleTimeUnit][_curBrokerTimeUnit] || !unitConverstion[_curRuleTimeUnit][_curBrokerTimeUnit](_curRuleTime,_curBrokerTime)) {
            callback(new Error('经纪人提醒时间需早于客户掉落时间哦！'));
        } else {
            callback();
        }
    };
    const rule = [
        {validator: validateNum, trigger: 'blur', name: '时间'}
    ];
    const numSize = [
        {validator: validateNum, trigger: 'blur', name: '时间'},
        {validator: validatePass2, trigger: 'blur', name: '时间'}
    ];
    return {
      data: {},
      setting: {
        unconfirmed_time: 0,
        no_report_record_time: 0
      },
      rules: {
        unconfirmed_time: rule,
        no_report_record_time: rule,
        no_look_record_time: rule,
        no_subscription_record_time: rule,
        follow_interval_limit_time: rule,
        unconfirmed_alert_time: numSize,
        no_report_record_alert_time: numSize,
        no_look_record_alert_time: numSize,
        no_subscription_record_alert_time: numSize,
        follow_interval_limit_alert_time: numSize,
      },
      switchList: ['unconfirmed_rule', 'no_report_record_rule', 'no_look_record_rule', 'no_subscription_record_rule', 'follow_interval_limit_rule'],
      ruleList: [
        {preText: '客户分配后超过', timeProp: 'unconfirmed_time', timeUnitProp: 'unconfirmed_time_unit', suffixText: '未跟进，将掉落公客池'},
        {preText1: '客户', preText2: '超过', name:'no_report_record_flow_type',type:'custom', timeProp: 'no_report_record_time', timeUnitProp: 'no_report_record_time_unit', suffixText: '未报备，将掉落公客池'},
        {preText1: '客户', preText2: '超过',name:'no_look_record_flow_type',type:'custom', timeProp: 'no_look_record_time', timeUnitProp: 'no_look_record_time_unit', suffixText: '未带看，将掉落公客池'},
        {preText1: '客户', preText2: '超过',name:'no_subscription_record_flow_type',type:'custom', timeProp: 'no_subscription_record_time', timeUnitProp: 'no_subscription_record_time_unit', suffixText: '未成交，将掉落公客池'},
        {preText: '客户距上次跟进时间超过', timeProp: 'follow_interval_limit_time', timeUnitProp: 'follow_interval_limit_time_unit', suffixText: '未跟进，将掉落公客池'}
      ],
      remindList: [
        {timeProp: 'unconfirmed_alert_time', timeUnitProp: 'unconfirmed_alert_time_unit'},
        {timeProp: 'no_report_record_alert_time', timeUnitProp: 'no_report_record_alert_time_unit'},
        {timeProp: 'no_look_record_alert_time', timeUnitProp: 'no_look_record_alert_time_unit'},
        {timeProp: 'no_subscription_record_alert_time', timeUnitProp: 'no_subscription_record_alert_time_unit'},
        {timeProp: 'follow_interval_limit_alert_time', timeUnitProp: 'follow_interval_limit_alert_time_unit'}
      ],
      sourceSetting:{},
      showSetting: false,
      no_drop_notice_admin_arr:[],
      admin_white_list_arr: [],
      sourceNDNA:[],
      sourceAWLR: []
    }
  },
  computed: {
    ...mapState({
      firmInfo: state => state.user.companyInfo
    }),
    getTimeRange () {
      const content = [];
      const times = JSON.parse(this.setting.unconfirmed_daily_protect_time_json || '[]');
      if (times.length > 0) {
        const time = JSON.parse(this.setting.unconfirmed_daily_protect_time_json);
        const timeStr = time.map(v => `${v[0]}-${v[1]}`).join('，');
        content.push(`每天「${timeStr}」`);
      }
      if (this.setting.unconfirmed_weekly_protect_time) {
        content.push(this.getWeeks);
      }
      return content.join('；');
    },
    getWeeks () {
      const list = ['周一', '周二', '周三', '周四', '周五', '周六', '周天'];
      if (!this.setting.unconfirmed_weekly_protect_time) return '';
      const ids = this.setting.unconfirmed_weekly_protect_time.split(',');
      const checkList = ids.map(v => {
        return list[Number(v) - 1];
      })
      return "每「" + checkList.join('、') + "」整天";
    }
  },
  created() {
    this.initial();
  },
  methods: {
    initial () {
      const status = Number(this.info.auto_shift_public_status);
      this.data = {
        auto_shift_public_status: status,
        auto_shift_public_status_active: status,
        send_public_pool_msg_status:this.info.send_public_pool_msg_status
      }
      this.setting = {
        ...this.info.auto_shift_public_setting
      }
      this.no_drop_notice_admin_arr = this.setting.no_drop_notice_admin_arr || [];
      this.admin_white_list_arr = this.setting.admin_white_list_arr || [];
      this.sourceNDNA = JSON.parse(JSON.stringify(this.no_drop_notice_admin_arr));
      this.sourceAWLR = JSON.parse(JSON.stringify(this.admin_white_list_arr));

      this.sourceSetting = JSON.parse(JSON.stringify(this.setting));
    },
    handleShowRule () {
      this.$refs.ruleRefs.open();
    },
    settingDate(){
        this.showSetting = true;
    },
    handleAddDate (info){
        this.$refs.datePickerRef.open(info);
    },
    handleTimePicker (data) {
      this.setting = Object.assign(this.setting, data);
    },
    handleWeekPicker (ids) {
      this.$set(this.setting, 'unconfirmed_weekly_protect_time', ids);
    },
    handleDatePicker (data){
        this.setting = Object.assign(this.setting, data);
    },
    handlePlatPicker ({list, text}) {
      this.$set(this.setting, 'source_white_list_text', text);
      this.$set(this.setting, 'source_white_list_arr', list);
    },
    // 打开添加不推送掉落通知的经纪人弹窗
    addPublicManual (type) {
      if (type == 1) {
        this.$refs.publicRobRef.open([...this.no_drop_notice_admin_arr], 1, {category: 1});
      } else if (type == 2) {
        this.$refs.publicRobRef.open([...this.admin_white_list_arr], 1, {category: 2});
      } else if (type == 3) {
        this.$refs.platformPickeRef.open([...this.setting.source_white_list_arr]);
      }
    },
    // 不推送掉落通知的经纪人
    removePublicUser (index, type) {
      if (type == 1) {
        this.no_drop_notice_admin_arr.splice(index, 1);
      } else if (type == 2) {
        this.admin_white_list_arr.splice(index, 1);
      }
    },
    handleConfirmRob (list, opt) {
      if (opt.category == 1) {
        this.no_drop_notice_admin_arr = list;
      } else if (opt.category == 2) {
        this.admin_white_list_arr = list;
      }
    },
    getResults () {
      return new Promise(resolve => {
        this.$refs.publicPoolDropForm.validate(valid => {
          if (!valid) {
            resolve({status: false});
          } else {
            let data = {
              auto_shift_public_status: this.data.auto_shift_public_status,
              send_public_pool_msg_status:this.data.send_public_pool_msg_status
            }
            if (data.auto_shift_public_status == 1) {
              data = {
                ...data,
                ...this.setting
              }
            }
            // 公客池不推送掉落通知的经纪人
            if (this.no_drop_notice_admin_arr.length > 0) {
              data.no_drop_notice_admin_ids = this.no_drop_notice_admin_arr.map(v => v.id).join(',');
            }else{
              data.no_drop_notice_admin_ids = ''
            }
            // 不受公客池掉落规则限制的特殊账号
            if (this.admin_white_list_arr.length > 0) {
              data.recycle_admin_white_list = this.admin_white_list_arr.map(v => v.id).join(',');
            } else {
              data.recycle_admin_white_list = '';
            }
            // 不受公客池掉落规则限制的客户来源
            if (this.setting.source_white_list_arr.length > 0) {
              data.recycle_source_white_list = this.setting.source_white_list_arr.join(',');
            } else {
              data.recycle_source_white_list = '';
            }
            resolve({status: true, data})
          }
        })
      })
    }
  },
}
</script>
<style lang="less" scoped>
.update-tips{
  display: inline-block;
  margin-left: 30px;
  color: red;
  line-height: 33px;
  font-size: 13px;
  a{
    text-decoration: underline;
    cursor: pointer;
  }
}
.inline{
  display: inline-block;
}
.tipMsg{
  display: inline;
  vertical-align: bottom;
}
.bus-set-conta .setting-table .protect-con .rule-con{
  line-height: 25px;
}
.bus-set-conta .setting-table .rule-con-week{
  margin-top: 0;
}
.bus-set-conta .setting-table .protect-con{
  margin-top: 0;
}
.bus-set-conta .setting-table .protect-con .settingDateBox{
  line-height: 20px;
  text-align: left;
  font-size: 12px;
}
.settingDateBtn{border: 0; padding-left: 0;padding-right: 0; }
.settingDateBtn:hover,.settingDateBtn:focus{background: transparent;}
.everyDay,.everyWeek{padding: 0 5px;font-size: 12px;}
.source-platform-list{
  max-width: 800px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  color: #666;
  padding-right: 10px;
}
</style>
<style lang="less">
.special-rule{
  width: 1200px;
  padding:20px;
  background-color: #F1F6FE;
}


  .pauseRule .el-input{margin-left: 0;}
// 弹出框样式
.public-pool-drop-actived-dialog{
  .el-dialog__header,.el-dialog__body{
    padding: 0;
    margin: 0;
  }
  .head{
    background: #f1f4fa;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    .el-icon-close{
      font-size: 23px;
      display: block;
    }
  }
  .title{
    color: #333;
    font-size: 18px;
    font-weight: bold;
    flex: 1;
  }
}
.setting-table{
  .el-form-item__error{
    text-align: left;
    padding-left: 10px;
  }
}
</style>
